import React, { useEffect, useState } from "react";
import "./AssessmentCrud.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCopy,
  faEye,
  faPenToSquare,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { sortByYearName } from "../sortingHelper";

const config = require("../../config.js");

const translations = {
  english: {    
    type: "Type",
    category: "Category",
    language: "Language",
    year: "Year",
    action: "Action",
    name: "Name",
    filters: "Filters",
    end: "Completed"
  },
  german: {
    type: "Art",
    category: "Kategorie",
    language: "Sprache",
    year: "Jahr",
    action: "Tätigkeit",
    name: "Name",
    filters: "Filter",
    end: "Vollendet"
  },
  italian: {
    type: "Tipo",
    category: "Categoria",
    language: "Lingua",
    year: "Anno",
    action: "Azione",
    name: "Nome",
    filters: "Filtri",
    end: "Completato"
  },
  czech: {
    type: "Typ",
    category: "Kategorie",
    language: "Jazyk",
    year: "Rok",
    action: "Akce",
    name: "Jméno",
    filters: "Filtry",
    end: "Dokončeno"
  },
};

function AssessmentCrudUser() {
  const [assessments, setAssessments] = useState([]);
  const [filteredAssessments, setFilteredAssessments] = useState([]);
  const navigate = useNavigate();
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem("language") || "english"
  );

  const calculateTable = () => {
    let newAssessments = assessments.filter((myAssessments) => {
      console.log(myAssessments, myFilters);
      if (myAssessments.examDescription && myAssessments.year && 
        myAssessments.examDescription
          .toLowerCase()
          .includes(myFilters.name.toLowerCase()) &&
        myAssessments.year.toLowerCase().includes(myFilters.year.toLowerCase())
      ) {
        return true;
      } else {
        return false;
      }
    });
    setFilteredAssessments(newAssessments);
  };

  let myFilters = {
    name: "",
    year: "",
  };

  const fetchAssessments = async () => {
    try {
      const response = await fetch(
        config.env.API_BASE_URL + "/api/results/user",
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setAssessments(data);
        setFilteredAssessments(data);
      } else {
        console.error("Failed to fetch assessments");
      }
    } catch (error) {
      console.error("Error fetching assessments:", error);
    }
  };

  useEffect(() => {
    fetchAssessments(); // Fetch assessments on component mount
  }, []);

  const handleUpdate = (result) => {
    navigate("/take-assessment", {
      state: {
        examName: result.examName,
        examCategory: result.examCategory,
        isMSS: result.isMSS,
        assessmentId: result.assessmentId._id,
        edit: true,
        disabled: false,
        resultId: result._id,
      },
    });
  };

  const handleVisualize = (result) => {
    navigate("/take-assessment", {
      state: {
        examName: result.examName,
        examCategory: result.examCategory,
        isMSS: result.isMSS,
        assessmentId: result.assessmentId._id,
        disabled: true,
        edit: true,
        resultId: result._id,
      },
    });
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(
        config.env.API_BASE_URL + `/api/results/user/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.ok) {
        setAssessments(
          assessments.filter((assessment) => assessment._id !== id)
        );
        fetchAssessments();
        alert("Assessment deleted successfully");
      } else {
        console.error("Failed to delete assessment");
      }
    } catch (error) {
      console.error("Error deleting assessment:", error);
    }
  };

  return (
    <>
      <div className="mt-5 Crud-main-container container"
        style={{ color: "#9C9CA5" }}>
        <div style={{ fontSize: "24px" }}>{translations[currentLanguage].filters}</div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            marginTop: "16px",
            marginBottom: "16px",
            gap: "24px",
            paddingLeft: "12px",
            paddingRight: "12px",
            placeContent: "center",
          }}
        >
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {translations[currentLanguage].name}
            </div>
            <input
              placeholder={translations[currentLanguage].name}
              onChange={(event) => {
                myFilters.name = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {translations[currentLanguage].year}
            </div>
            <input
              placeholder={translations[currentLanguage].year}
              onChange={(event) => {
                myFilters.year = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
        </div>
        <table className="table Crud-main container">
          <thead>
            <tr className="Crud-thead-wrapper">
              <th scope="col">{translations[currentLanguage].name}</th>
              <th scope="col">{translations[currentLanguage].type}</th>
              <th scope="col">{translations[currentLanguage].category}</th>
              <th scope="col">{translations[currentLanguage].language}</th>
              <th scope="col">{translations[currentLanguage].year}</th>
              <th scope="col">{translations[currentLanguage].end}</th>
              <th scope="col">{translations[currentLanguage].action}</th>
            </tr>
          </thead>
          <tbody>
            {filteredAssessments
              .slice()
              .sort(sortByYearName)
              .map((assessment) => (
                <tr key={assessment._id}>
                  <td>{assessment.examDescription}</td>
                  <td>{assessment.examName}</td>
                  <td>{assessment.examCategory}</td>
                  <td>{assessment.assessmentId.language}</td>
                  <td>{assessment.year}</td>
                  <td>{assessment.end ? 'Yes' : 'No'}</td>
                  <td>
                    <FontAwesomeIcon
                      onClick={() => handleUpdate(assessment)}
                      className="icon"
                      icon={faPenToSquare}
                    />
                    <FontAwesomeIcon
                      onClick={() => handleVisualize(assessment)}
                      className="icon"
                      icon={faEye}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        if (
                          window.confirm(
                            "Are you sure you want to delete this assessment?"
                          )
                        ) {
                          handleDelete(assessment._id);
                        }
                      }}
                      className="icon trash"
                      icon={faTrashCan}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default AssessmentCrudUser;
